<template>
  <v-container>
      <v-layout justify-center wrap>
          <v-flex xs12>
              <w-main-title
                      class="pb-0"
                      title="Configuración del sistema"
                      :breadcrumbs="breadcrumbs"
              ></w-main-title>
          </v-flex>
          <v-flex xs12>
              <v-card class="kim-card">
                  <v-layout>
                      <v-flex class="hidden-sm-and-down secondary-card">
                          <menu-settings :menu="menu" :clickFn="loadComponent" :selected="componentLoaded"></menu-settings>
                      </v-flex>
                      <v-divider vertical></v-divider>
                      <v-flex xs12 md9>
                          <v-toolbar dense flat color="primary" dark class="hidden-md-and-up">
                              <v-btn icon @click="drawer = !drawer" class="hidden-md-and-up">
                                  <v-icon>menu</v-icon>
                              </v-btn>
                              <v-toolbar-title class="font-weight-light ml-0">{{title}}</v-toolbar-title>
                          </v-toolbar>
                          <menu-settings :menu="menu" :clickFn="loadComponent" v-if="drawer" class="hidden-md-and-up"></menu-settings>
                          <v-card-text v-else class="pa-4" style="min-height:420px;">
                              <component :is="componentLoaded" :loading="loading" @click:payment-account="onPaymentAccountClick"></component>
                          </v-card-text>
                      </v-flex>
                  </v-layout>
              </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>

    import {userRoleIs, SPECIALIST} from '@/utils/Specialist'
    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'
    import { ApiUtils } from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'


export default {
  components: {
    WMainTitle: () => import('../../components/common/WMainTitle'),
    MenuSettings: () => import('../../components/providers/settings/MenuSettings'),
    AppointmentSettings: () => import('../../components/providers/settings/AppointmentSettings'),
    Appearance: () => import('../../components/providers/settings/Appearance'),
    ProviderData: () => import('../../components/providers/settings/ProviderProfileSettings'),
    ToolsSettings: () => import('../../components/providers/settings/ToolsSettings'),
    PaymentAccount: () => import('../../components/providers/settings/PaymentAccount'),
    ClinicalRecord: () => import('../../components/providers/settings/ClinicalRecord'),
    SubscriptionSettings: () => import('../../components/providers/settings/SubscriptionSettings'),
    LabelsSettings: () => import('@/components/providers/settings/LabelsSettings'),
  },
  data() {
    return {
      breadcrumbs: [
          {
              text: 'Configuración',
              disabled: true,
              href: ''
          },
      ],
      drawer: false,
      title: '',
      componentLoaded: '',
      loading: false
    }
  },
    beforeDestroy(){
        var vm = this
        if(!vm.currentProvider) return
        leaveChannel(`provider.${vm.currentProvider.id}.settings`)
    },
    mounted() {
        var vm = this
        vm.setDefaultView()
        if(vm.currentProvider){
            subscribeToPrivateChannelEvents(`provider.${vm.currentProvider.id}.settings`, {
                'PaymentAccountVerified': vm.onPaymentAccountVerified
            })
        }

    },
    computed:{
        ...mapState(['currentUser', 'currentProvider']),
        view(){
          const vm = this
          return vm.$route.query && vm.$route.query.view || ''
        },
        isInstitution(){
            var vm = this
            return !!vm.currentProvider && !!vm.currentProvider.institution
        },
        isOwner(){
            var vm = this
            return   !!vm.currentProvider && vm.currentProvider.role.is_owner
        },
        isOwnerOrAdmin(){
            var vm = this
            return !!vm.currentProvider && (vm.currentProvider.role.is_owner || vm.currentProvider.role.is_admin)
        },
        menu(){

            var vm = this
            var menu = []

            if(vm.isOwnerOrAdmin){
                menu = [
                    {
                      icon: 'fas fa-building',
                      text: 'Perfil Proveedor',
                      component: 'ProviderData'
                    },
                    {
                      icon: 'far fa-calendar-alt',
                      text: 'Agenda',
                      component: 'AppointmentSettings'
                    },
                    {icon: 'fas fa-tags', text: 'Etiquetas', component: 'LabelsSettings'},
                    {icon: 'fas fa-images', text: 'Apariencia', component: 'Appearance'},
                ]
            }

            if(vm.isOwner){
                menu = [
                    ...menu,
                    {icon: 'fas fa-id-card-alt', text: 'Mi Subscripción', component: 'SubscriptionSettings'},
                    {icon: 'fas fa-money-check', text: 'Cuenta de Cobro', component: 'PaymentAccount'},
                ]
            }

            if(userRoleIs(SPECIALIST) || vm.isOwnerOrAdmin){
                menu = [
                    ...menu,
                  {
                    icon: 'far fa-file-alt',
                    text: 'Ficha',
                    component: 'ClinicalRecord'
                  },
                  {
                      icon: 'fas fa-toolbox',
                      text: 'Herramientas',
                      component: 'ToolsSettings'
                  },
                  /*{
                      icon: 'fas fa-briefcase-medical',
                      text: 'Mis convenios',
                      component: 'Appearance'
                  }*/
                ]
            }

            return menu

        }
    },
  methods: {
      ...mapMutations(['setCurrentProvider', 'showSnackBar']),
      setDefaultView(){
        const vm = this
        if(vm.view){
          let menu = vm.menu.find(menu => menu.component === vm.view)
          if(menu){
            vm.loadComponent(menu)
          }else{
              vm.loadComponent(vm.menu[0])
          }
        }else{
          vm.loadComponent(vm.menu[0])
        }
      },
      onPaymentAccountVerified({account}){
          var vm = this
          if(!vm.currentProvider) return
          var provider = JSON.parse(JSON.stringify(vm.currentProvider))
          provider.settings.payment_account = account
          vm.setCurrentProvider({provider})
          vm.showSnackBar({
              text: 'Tu cuenta de cobro ha sido verificada!',
              color: 'success'
          })
      },
      onPaymentAccountClick(){

          this.loadComponent({text: 'Cuenta de Cobro', component: 'PaymentAccount'})
      },
    loadComponent(item) {
      this.drawer = false
      this.title = item.text
      this.componentLoaded = item.component
    }
  },
  watch:{
    currentProvider(val, oldVal){
      const vm = this
      if(val && oldVal && (val.id !== oldVal.id)){
        vm.setDefaultView()
      }
    }
  }
}
</script>
